import { render, staticRenderFns } from "./MarketingMerchantsList.vue?vue&type=template&id=8e9648f0&scoped=true&"
import script from "./MarketingMerchantsList.vue?vue&type=script&lang=js&"
export * from "./MarketingMerchantsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9648f0",
  null
  
)

export default component.exports